import { defineStyleConfig } from '@chakra-ui/react';
import { ThemeColorToken, ThemeFontSizeToken, ThemeFontToken, ThemeRadiusToken, ThemeSpaceToken, } from '../theme-tokens';
export const dateCellConfig = defineStyleConfig({
    baseStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        padding: '12px 8px',
        borderRadius: ThemeRadiusToken.Small,
        fontSize: ThemeFontSizeToken.Medium,
        fontFamily: ThemeFontToken.Body,
        color: ThemeColorToken.OnSurface,
        position: 'relative',
        border: '2px solid transparent',
        zIndex: 1,
        marginLeft: 1,
        marginRight: 1,
        span: {
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            top: '50%',
            left: '50%',
            width: '24px',
            height: '1px',
            transform: 'translate(-50%,-50%)rotate(-45deg)',
            background: ThemeColorToken.OnSurface,
        },
        _hover: {
            background: ThemeColorToken.AccentHoverAlpha,
        },
        _active: {
            background: ThemeColorToken.AccentActiveAlpha,
        },
        _focus: {
            background: ThemeColorToken.AccentContainer,
            border: '2px solid',
            borderColor: ThemeColorToken.Info,
            outlineColor: ThemeColorToken.Info,
        },
        _disabled: {
            cursor: 'not-allowed',
            opacity: 0.48,
        },
    },
    variants: {
        normal: {
            _disabled: {
                _hover: {
                    background: 'none',
                },
            },
        },
        outSideMonth: {
            color: ThemeColorToken.OnBackgroundSubdued,
            _disabled: {
                background: 'none',
            },
        },
        isSelectedRangeDay: {
            background: ThemeColorToken.AccentContainer,
            color: ThemeColorToken.OnSurface,
            marginRight: ThemeSpaceToken.None,
            marginLeft: ThemeSpaceToken.None,
            borderRadius: 'none',
            _disabled: {
                background: ThemeColorToken.AccentContainer,
                color: ThemeColorToken.OnSurface,
            },
            _hover: {
                border: `solid 1px ${ThemeColorToken.Accent}`,
                background: ThemeColorToken.AccentHover,
                color: ThemeColorToken.OnAccent,
            },
        },
        currentDay: {
            color: ThemeColorToken.Accent,
            _disabled: {
                color: ThemeColorToken.Accent,
                _active: {
                    border: 'none',
                },
            },
            span: {
                background: ThemeColorToken.Accent,
            },
            _hover: {
                color: ThemeColorToken.AccentHover,
                _disabled: {
                    background: 'none',
                },
            },
            _active: {
                color: ThemeColorToken.AccentActive,
                borderColor: ThemeColorToken.AccentActive,
            },
        },
        selectedDay: {
            background: ThemeColorToken.Accent,
            color: ThemeColorToken.OnAccent,
            span: {
                background: ThemeColorToken.OnAccent,
            },
            _hover: {
                background: ThemeColorToken.AccentHover,
                _disabled: {
                    background: ThemeColorToken.Accent,
                },
            },
            _active: {
                background: ThemeColorToken.AccentActive,
            },
            _focus: {
                background: ThemeColorToken.Accent,
                borderColor: ThemeColorToken.Info,
            },
        },
        startDateRange: {
            background: ThemeColorToken.Accent,
            color: ThemeColorToken.OnAccent,
            borderTopRightRadius: ThemeRadiusToken.None,
            borderBottomRightRadius: ThemeRadiusToken.None,
            marginRight: ThemeSpaceToken.None,
            span: {
                background: ThemeColorToken.OnAccent,
            },
            ':hover': {
                background: ThemeColorToken.AccentHover,
                _disabled: {
                    background: ThemeColorToken.Accent,
                },
            },
            _active: {
                background: ThemeColorToken.AccentActive,
            },
            _focus: {
                background: ThemeColorToken.Accent,
                borderColor: ThemeColorToken.Info,
            },
        },
        endDateRange: {
            background: ThemeColorToken.Accent,
            color: ThemeColorToken.OnAccent,
            borderTopLeftRadius: ThemeRadiusToken.None,
            borderBottomLeftRadius: ThemeRadiusToken.None,
            marginLeft: ThemeSpaceToken.None,
            span: {
                background: ThemeColorToken.OnAccent,
            },
            ':hover': {
                background: ThemeColorToken.AccentHover,
                _disabled: {
                    background: ThemeColorToken.Accent,
                },
            },
            _active: {
                background: ThemeColorToken.AccentActive,
            },
            _focus: {
                background: ThemeColorToken.Accent,
                borderColor: ThemeColorToken.Info,
            },
        },
    },
});
//# sourceMappingURL=date-cell-theme.js.map